import api from '../api/api';

let inflight = null;
let cached = null;

export async function loadHomepageBlogs({ limit = 10, force = false } = {}) {
  if (!force && cached) {
    return cached;
  }
  if (!force && inflight) {
    return inflight;
  }

  inflight = api
    .get('/api/v1/pdf_parser/blogs/', {
      params: { random: 1, limit },
    })
    .then(({ data }) => {
      const result = {
        blogs: data?.blogs || [],
        count: data?.count ?? 0,
      };
      cached = result;
      inflight = null;
      return result;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
}

export function clearHomepageBlogsCache() {
  cached = null;
  inflight = null;
}
